import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as React from 'react';

export const BasicFormElement = ({label, children, description = ''}) => {
  return (
    <>
      <Form.Group as={Row}>
        <Form.Label column sm="3">
          {label}
        </Form.Label>
        <Col sm="3">{children}</Col>
      </Form.Group>
      {description && description !== '' && (
        <div className="text-muted" style={{marginTop: -13, marginBottom: 13}}>
          {description}
        </div>
      )}
    </>
  );
};
